import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stock-dash-board',
  templateUrl: './stock-dash-board.component.html',
  styleUrls: ['./stock-dash-board.component.scss']
})
export class StockDashBoardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
